// extracted by mini-css-extract-plugin
export default {"details":"A6CrV5kgNM","details-dropdown":"RalNQdVVRv","detailsDropdown":"RalNQdVVRv","details-button":"_3PF+89zFrM","detailsButton":"_3PF+89zFrM"};